import { render } from "./PledgeButton.vue?vue&type=template&id=72b92002"
import script from "./PledgeButton.vue?vue&type=script&lang=js"
export * from "./PledgeButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__